// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 320px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "price-13Eel";
var _5 = "price__money-bhLWf";
var _6 = "selectedFare__price-ytAh3";
var _7 = "selectedFare-LG0X4";
var _8 = "selectedFare__priceWrappe-28w7X";
var _9 = "price__wrapper-2nVO-";
var _a = "flight-1na8M";
export { _1 as "__esModule", _2 as "iphone5", _3 as "mobile", _4 as "price", _5 as "price__money", _6 as "selectedFare__price", _7 as "selectedFare", _8 as "selectedFare__priceWrappe", _9 as "price__wrapper", _a as "flight" }
export default { "__esModule": _1, "iphone5": _2, "mobile": _3, "price": _4, "price__money": _5, "selectedFare__price": _6, "selectedFare": _7, "selectedFare__priceWrappe": _8, "price__wrapper": _9, "flight": _a }
